import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/clientesapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
import PzBanner from "@/commons/titles/PzTitleBanner";
export default {
  name: 'App',
  components: {
    PzBanner: PzBanner
  },
  provide: function provide() {
    return {
      app: this,
      formulario: ''
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('app/getLocation');

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};